import component from './LayoutAiCreator.vue'
export default component
